import styled from "styled-components";
import {AnonymousButtonsContainerDefaultBox} from "./anonymous-buttons-container.default.box";

export const AnonymousButtonsContainerHarrahsBox = styled(AnonymousButtonsContainerDefaultBox)`
  flex-direction: row-reverse;
`;
